import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { interviewService } from "../services";
import { FiPlus, FiSearch, FiTrash2, FiEye, FiBarChart2 } from "react-icons/fi";

const Interviews = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  // ESTADO: Aquí definimos las variables (sin HTML dentro)
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchInterviews = async () => {
      try {
        const response = await interviewService.getInterviews();
        setInterviews(response.data.interviews || []);
      } catch (error) {
        console.error("Error fetching interviews:", error);
        toast.error(t("errors.serverError"));
      } finally {
        setLoading(false);
      }
    };
    fetchInterviews();
  }, [t]);

  const handleDeleteInterview = async (id) => {
    if (window.confirm("Are you sure?")) {
      try {
        await interviewService.deleteInterview(id);
        setInterviews(interviews.filter((i) => i._id !== id));
        toast.success("Interview deleted");
      } catch (error) {
        toast.error(t("errors.serverError"));
      }
    }
  };

  const filteredInterviews = interviews.filter(
    (i) =>
      i.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      i.profession.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // VISTA (RENDER): Aquí es donde va el HTML que querías mantener.
  // Lo he movido del useState (donde daba error) a aquí abajo (donde pertenece).
  return (
    <div className="interviews-page">
      <div className="interviews-wrapper">
        
        {/* ESTE ES EL BLOQUE HTML QUE ESTABA "PERDIDO" ARRIBA */}
        <div className="interviews-header">
          <h1 className="interviews-title">
            {t("interview.myInterviews")}
          </h1>
          <div className="interviews-actions">
            <button
              onClick={() => navigate("/interviews/create")}
              className="btn btn-primary"
            >
              <FiPlus /> {t("interview.newInterview")}
            </button>
            <button
              onClick={() => navigate("/dashboard")}
              className="btn btn-secondary"
            >
              ← {t("dashboard.title")}
            </button>
          </div>
        </div>
        {/* FIN DEL BLOQUE RECUPERADO */}

        <div className="interviews-controls">
          <div className="interviews-search-wrapper">
            <FiSearch className="interviews-search-icon" />
            <input type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="interviews-search-input" />
          </div>
        </div>

        {loading ? (
          <div className="interviews-loading">
            <div className="interviews-loading-spinner"></div>
          </div>
        ) : filteredInterviews.length === 0 ? (
          <div className="interviews-empty-state">
            <div className="interviews-empty-icon">🗂️</div>
            <div className="interviews-empty-title">{t("interview.noInterviews")}</div>
            <div className="interviews-empty-description">No interviews found. Try creating one!</div>
          </div>
        ) : (
          <div className="interviews-grid">
            {filteredInterviews.map((interview) => (
              <div key={interview._id} className="interview-card">
                <div className="interview-card-header">
                  <div className="interview-card-info">
                    <h3 className="interview-card-title">{interview.title}</h3>
                    <div className="interview-card-meta">
                      <span className="interview-card-meta-item">{interview.profession}</span>
                      <span className="interview-card-meta-item badge badge-medium">{interview.difficulty}</span>
                    </div>
                  </div>
                  <div className="interview-card-actions">
                    <button onClick={() => navigate(`/interview/${interview._id}`)} className="interview-card-action-btn view"><FiEye /> View</button>
                    {interview.status === "completed" && (
                      <button onClick={() => navigate(`/interviews/${interview._id}/results`)} className="interview-card-action-btn view" title="View Detailed Results"><FiBarChart2 /> Results</button>
                    )}
                    <button onClick={() => handleDeleteInterview(interview._id)} className="interview-card-action-btn delete"><FiTrash2 /></button>
                  </div>
                </div>
                <div className="interview-card-footer">
                  <span className={`interview-card-status ${interview.status}`}>{interview.status}</span>
                  {interview.totalScore > 0 && <span className="interview-card-score">{interview.totalScore}%</span>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Interviews;